var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"content"}},[_c('el-card',{staticClass:"box-card content-text"},[_vm._t("leftContainer")],2),_c('div',{staticClass:"content-know"},[_c('el-card',{staticClass:"box-card ptop10"},[_vm._t("rightContainer")],2)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }